import { TypedDocumentString } from '@haaretz/s-fragments/structures';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '@haaretz/s-graphql-fetcher';
export const ArticleLinkDataBsQueryDocument = new TypedDocumentString(`
    query ArticleLinkDataBSQuery($model: PageModelInput!, $dateFormat: String, $expand: String) {
  Page(model: $model, dateFormat: $dateFormat, expand: $expand) {
    lineage {
      name: body
      url: href
    }
    seoData {
      canonicalUrl
    }
  }
}
    `);
export const useArticleLinkDataBsQuery = (variables, options)=>{
    return useQuery({
        queryKey: [
            'ArticleLinkDataBSQuery',
            variables
        ],
        queryFn: fetch(ArticleLinkDataBsQueryDocument, variables),
        ...options
    });
};
useArticleLinkDataBsQuery.document = ArticleLinkDataBsQueryDocument;
useArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery',
        variables
    ];
export const useSuspenseArticleLinkDataBsQuery = (variables, options)=>{
    return useSuspenseQuery({
        queryKey: [
            'ArticleLinkDataBSQuery',
            variables
        ],
        queryFn: fetch(ArticleLinkDataBsQueryDocument, variables),
        ...options
    });
};
useSuspenseArticleLinkDataBsQuery.document = ArticleLinkDataBsQueryDocument;
useSuspenseArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery',
        variables
    ];
export const useInfiniteArticleLinkDataBsQuery = (variables, options)=>{
    return useInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? [
                'ArticleLinkDataBSQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(ArticleLinkDataBsQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useInfiniteArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery.infinite',
        variables
    ];
export const useSuspenseInfiniteArticleLinkDataBsQuery = (variables, options)=>{
    return useSuspenseInfiniteQuery((()=>{
        const { queryKey: optionsQueryKey, ...restOptions } = options;
        return {
            queryKey: optionsQueryKey ?? [
                'ArticleLinkDataBSQuery.infinite',
                variables
            ],
            queryFn: (metaData)=>fetch(ArticleLinkDataBsQueryDocument, {
                    ...variables,
                    ...metaData.pageParam ?? {}
                })(),
            ...restOptions
        };
    })());
};
useSuspenseInfiniteArticleLinkDataBsQuery.getKey = (variables)=>[
        'ArticleLinkDataBSQuery.infinite',
        variables
    ];
useArticleLinkDataBsQuery.fetcher = (variables, options)=>fetch(ArticleLinkDataBsQueryDocument, variables, options);

//# sourceMappingURL=ArticleLinkDataBS.js.map